import { token } from '@terra/ui-styled-system';

export function getConfidenceColor(confidence: number | null): string {
  if (confidence === null) return token('colors.fg.muted');
  if (confidence >= 4) return token('colors.fg.status.resolved');
  if (confidence >= 3) return token('colors.fg.neutral.warning');
  return token('colors.fg.severity.critical');
}

export function getConfidenceLabel(confidence?: number | null): string | null {
  if (!confidence) return null;
  if (confidence >= 5) return 'HIGHEST';
  if (confidence >= 4) return 'HIGH';
  if (confidence >= 3) return 'MEDIUM';
  if (confidence >= 2) return 'LOW';
  return 'LOWEST';
}

export function getRankColor(rank: string): string {
  switch (rank.toUpperCase()) {
    case 'APPROVED':
      return token('colors.fg.status.resolved');
    case 'REJECTED':
      return token('colors.fg.status.unresolved');
    default:
      return token('colors.fg.muted');
  }
}

export function getSeverityVariant(
  severity?: string,
): 'solid' | 'outline' | 'subtle' {
  switch (severity?.toLowerCase()) {
    case 'high':
      return 'solid';
    case 'medium':
      return 'outline';
    case 'low':
      return 'subtle';
    default:
      return 'outline';
  }
}

export function getBadgeStyle(color: string): {
  backgroundColor: string;
  color: string;
} {
  return {
    backgroundColor: `${color}20`,
    color: color,
  };
}

export function getConfidenceBadgeStyle(confidence: number | null) {
  const color = getConfidenceColor(confidence);
  return getBadgeStyle(color);
}

export function getRankBadgeStyle(rank: string) {
  const color = getRankColor(rank);
  return getBadgeStyle(color);
}
